import { Injectable } from '@angular/core';

// add my services and common stuff here
import * as Constants from 'src/app/services/constants/constants';


@Injectable()
export class AmbitPushGeneral 
{
  consoleLog:boolean = true;

  isForeground:boolean;
  ForegroundStatus:string = "";

  message:string = "";
  title:string = "";
  subtitle:string = "";
  timeStamp:string = ""; 
  // identifiers (2019-04-24)
  EventId:number = 0;
  ApiLogId:number = 0;
  AbstractId:number = 0;

  // specific identifiers
  AmbitMessageId:number = 0;
  SurveyBroadcastId:number = 0;
  SurveyRecipientId:number = 0;
  ActionableBroadcastId:number = 0;
  //
  AmbitEventTypeId:number = 0;
  AmbitEventTypeCode:string = "";
  NotificationTypeCode:string = "";

  // StructuredFormType replaces MessageType
  MessageTypeCode:string = "";  // to be deprecated in favour of StructuredFormTypeCode
  StructuredFormTypeCode:string = ""; // replaces use of legacy MessageTypeCode

  MobileUserId:string = "";
  MobileDeviceId:string = "";
  OrganizationId:string = "";
  OrganizationCode:string = "";
  urlRouteUserToAmbit:string = "";

  constructor(notificationPayload:any, ForegroundStatus:string) 
  { 
    if (this.consoleLog) console.log('AmbitPushGeneral.ctor - LifeCycle', notificationPayload); 

    if (!notificationPayload) { return; }
    
    this.isForeground = (ForegroundStatus === "FOREGROUND")? true : false;
    this.ForegroundStatus = ForegroundStatus;
    
    this.message = notificationPayload.message || "";
    this.title = notificationPayload.title || "";
    this.subtitle = notificationPayload.subtitle || "";
    this.timeStamp = notificationPayload.timeStamp || "";

    this.ApiLogId = this.ToNumber(notificationPayload.ApiLogId, 0);
    this.EventId = this.ToNumber(notificationPayload.EventId, 0);

    this.AmbitEventTypeId = this.ToNumber(notificationPayload.AmbitEventTypeId, 0);
    this.AmbitEventTypeCode = notificationPayload.AmbitEventTypeCode || "";

    // StructuredFormType replaces MessageType
    this.MessageTypeCode = notificationPayload.MessageTypeCode || "";
    this.StructuredFormTypeCode = notificationPayload.StructuredFormTypeCode || "";
    if (!this.StructuredFormTypeCode)
    {
      this.StructuredFormTypeCode = this.MessageTypeCode; // temporary backwards compatibility (to be removed)
    }
    

    this.MobileUserId = notificationPayload.MobileUserId || "";
    this.MobileDeviceId = notificationPayload.MobileDeviceId || "";
    this.OrganizationId = notificationPayload.OrganizationId || "";
    this.OrganizationCode = notificationPayload.OrganizationCode || "";
    this.urlRouteUserToAmbit = notificationPayload.urlRouteUserToAmbit || "";

    if (notificationPayload.StructuredFormTypeCode === Constants.NOTIFICATION_TYPE_ACTIONABLE)  // NOTE THAT THIS IS MessageTypeCode!!
    {
      // special handling for Actionable *until* API returns this in AmbitEventTypeCode instead of SURVEY for both
      this.NotificationTypeCode = Constants.NOTIFICATION_TYPE_ACTIONABLE;  // instead of SURVEY
      this.ActionableBroadcastId = this.ToNumber(notificationPayload.SurveyBroadcastId, 0);  // SurveyRecipientId;
      this.AbstractId = this.ToNumber(notificationPayload.SurveyBroadcastId, 0);  // SurveyRecipientId;
    }
    else if (notificationPayload.AmbitEventTypeCode === Constants.NOTIFICATION_TYPE_SURVEY)
    {
      this.NotificationTypeCode = Constants.NOTIFICATION_TYPE_SURVEY; 
      this.SurveyBroadcastId = this.ToNumber(notificationPayload.SurveyBroadcastId, 0);
      this.SurveyRecipientId = this.ToNumber(notificationPayload.SurveyRecipientId, 0); 
      this.AbstractId = this.ToNumber(notificationPayload.SurveyBroadcastId, 0);  // SurveyRecipientId;
    }
    else if (notificationPayload.AmbitEventTypeCode === Constants.NOTIFICATION_TYPE_AMBITMESSAGE) 
    {
      this.NotificationTypeCode = Constants.NOTIFICATION_TYPE_AMBITMESSAGE;  // may be overridden below 
      this.AmbitMessageId = this.ToNumber(notificationPayload.AmbitMessageId, 0);
      this.AbstractId = this.ToNumber(notificationPayload.AmbitMessageId, 0);  // SurveyRecipientId;

      // ---------------------------------------------------------------------
      // may be overridden below (TEMP HACK until we get rid of old mobile app and switch API code to use EVENTNOTIFICATION
      let EventNotificationFlag = this.ToBoolean(notificationPayload.EventNotificationFlag, false);
      if (EventNotificationFlag === true)
      {
        this.NotificationTypeCode = Constants.NOTIFICATION_TYPE_EVENTNOTIFICATION; 
      } 
      // ---------------------------------------------------------------------
    }
    else if (notificationPayload.AmbitEventTypeCode === Constants.NOTIFICATION_TYPE_EVENTNOTIFICATION) 
    {
      this.NotificationTypeCode = Constants.NOTIFICATION_TYPE_EVENTNOTIFICATION; 
      this.AmbitMessageId = this.ToNumber(notificationPayload.AmbitMessageId, 0);
      this.AbstractId = this.ToNumber(notificationPayload.AmbitMessageId, 0);  // SurveyRecipientId;
    }
    else  // unexpected ...
    {
      this.NotificationTypeCode = notificationPayload.AmbitEventTypeCode; // SURVEY | MONITOR | etc.
    }
  }

  // HELPER FUNCTIONS
  ToBoolean(inValue:any, defaultValue:boolean):boolean
  {
    try
    {
      if ((typeof inValue === 'undefined')  || (inValue === null) || (inValue === "{}"))
      {
        return defaultValue;
      }
  
      // usually we expect "TRUE" to be the value, 
      // but adding other possibilities without doing all the string toUpper conversion
      let myBool = inValue === true || inValue === "TRUE" || inValue === "true" || inValue === "True";
  
      return myBool;
    }
    catch (error)
    {
      console.error("AmbitPushGeneral.ConvertToBoolean error: " + inValue, error);
      return defaultValue;
    }
  }
  ToNumber(value:number, defaultValue:number):number
  {
    try
    {
      return value;
    }
    catch (error)
    {
      console.error("AmbitPushGeneral.ConvertToNumber error: " + value, error);
      return defaultValue;
    }
  }
  ToString(value:string, defaultValue:string):string
  {
    try
    {
      return value;
    }
    catch (error)
    {
      console.error("AmbitPushGeneral.ToString error: " + value, error);
      return defaultValue;
    }
  }
}
